<template>
  <div class="container-warp">
    <div class="icon-404"></div>
    <div class="text-404">
      <span class="title">页面迷路了</span>
      <span class="info">1. 请确认访问地址是否有误</span>
      <span class="info">2. 请检查网络环境是否通畅</span>
    </div>
    <div class="back-index-btn">
      <van-button text="返回首页"
                  type="info"
                  @click="jumpIndexPage"></van-button>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    jumpIndexPage() {
      this.$router.push({ path: '/index' })
    }
  },
}
</script>

<style lang="less" scoped>
.icon-404 {
  display: flex;
  background: url("~@/assets/images/notFound.png") no-repeat;
  background-size: 100% 100%;
  width: 187px;
  height: 144px;
  margin: 80px auto 10px auto;
  .pic-404 {
    width: 100%;
    height: 100%;
  }
}
.text-404 {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 14px;
  .title {
    font-weight: 600;
    margin-bottom: 10px;
  }
  .info {
    margin-bottom: 6px;
  }
}
.back-index-btn {
  width: 80%;
  margin: 0 auto;
  margin-top: 30px;
  text-align: center;
}
</style>
